import React from "react"
import { graphql } from 'gatsby'
import { Layout, Stack, Main } from '@layout'
import Seo from '@widgets/Seo'
import Divider from '@components/Divider'
import PageTitle from '@components/PageTitle'
import { Box, Text, Card, Flex, Button } from 'theme-ui'

const styles = {
    imageWrapper: {
      borderRadius: `default`,
      overflow: `hidden`,
      position: `relative`
    },
    button: {
      display: [`none`, `block`],
      position: `absolute`,
      bottom: 4,
      right: 4
    },
    grid: {
      flexWrap: [`wrap`, null, `nowrap`],
      ' > div + div': {
        ml: [0, 0, 5]
      }
    },
    column: {
      flex: `auto`,
      flexBasis: [`full`, null, `1/2`],
      fontSize: 3,
      textAlign: `justify`
    }
  } 

export default function Template (props)  {
    const { data: { markdownRemark } } = props // data.markdownRemark holds our post data
    const { frontmatter, html } = markdownRemark
  
    return (
      <Layout {...props}>
        <Seo title='About' />
        <Divider />
        <Stack>
          <Main>
            <PageTitle
              header={frontmatter.title}
            />
            <Divider />
            <Flex sx={styles.grid}>
              <Box sx={styles.column}>
                  <Card variant='paper'>
                   <div
                        className="blog-post-content"
                        dangerouslySetInnerHTML={{ __html: html }}
                    />
                  </Card>
              </Box>
            </Flex>
          </Main>
        </Stack>
      </Layout>
    )
  }

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        slug
        title
      }
    }
  }
`